<template>
<div>
    <b-navbar type="dark" :variant="env.APP_NAVBAR_BG" class="px-2">
        <b-navbar-brand href="/"><strong>{{ env.APP_NAME }}</strong></b-navbar-brand>

        <b-navbar-nav class="mr-auto">
            <template v-if="auth_level === '300'">
                <b-nav-item-dropdown toggle-class="b-nav-item-text-icon">
                    <template v-slot:button-content>
                        <small>出品</small>
                        <br>
                        <font-awesome-icon icon="camera" class="fa-fw" />
                    </template>
                    <b-dropdown-item :href="env.ECL_URL">Easy Card Lister出品</b-dropdown-item>
                    <b-dropdown-item to="/me/listings">出品の一覧・手動出品</b-dropdown-item>
                </b-nav-item-dropdown>
            </template>

            <template v-if="auth_functions.sync === true">
                <b-nav-item to="/me/items" link-classes="b-nav-item-text-icon">
                    <small>在庫</small>
                    <br>
                    <font-awesome-icon icon="box-full" class="fa-fw" />
                </b-nav-item>

                <b-nav-item to="/me/orders" link-classes="b-nav-item-text-icon">
                    <small>注文</small>
                    <br>
                    <font-awesome-icon icon="shopping-cart" class="fa-fw" />
                </b-nav-item>
<!--
                <b-nav-item to="/me/marunage" link-classes="b-nav-item-text-icon">
                    <small>丸投</small>
                    <br>
                    <font-awesome-icon icon="robot" class="fa-fw" />
                </b-nav-item>
-->
            </template>

<!--
            <b-nav-item to="/me/shippings" link-classes="b-nav-item-text-icon">
                <font-awesome-icon icon="shipping-fast" class="fa-fw" />
            </b-nav-item>
-->
            <b-nav-item-dropdown toggle-class="b-nav-item-text-icon">
                <template v-slot:button-content>
                    <small>配送</small>
                    <br>
                    <font-awesome-icon icon="shipping-fast" class="fa-fw" />
                </template>
                <b-dropdown-item to="/me/shippings">DHL</b-dropdown-item>
                <template v-if="auth_functions['shipping.ecms'] === true">
                    <b-dropdown-item to="/me/shippings/ecms_order">ECMS出荷</b-dropdown-item>
                </template>
            </b-nav-item-dropdown>

            <b-nav-item to="/me/insurances" link-classes="b-nav-item-text-icon">
                <small>保険</small>
                <br>
                <font-awesome-icon icon="shield-alt" class="fa-fw" />
            </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right toggle-class="b-nav-item-text-icon">
                <template v-slot:button-content>
                    <small>取説</small>
                    <br>
                    <font-awesome-icon icon="question-circle" class="fa-fw" />
                </template>
                <b-dropdown-item href="https://kamo2.tuskey.one/manual/" target="_blank">マニュアル</b-dropdown-item>
                <b-dropdown-item href="https://docs.google.com/spreadsheets/d/1Hl2MX4aVVKztw9nXPQudEcqzI7up46MrE1wujp8zqTI/edit#gid=179588924" target="_blank">Q＆A</b-dropdown-item>
                <b-dropdown-item href="https://docs.google.com/spreadsheets/d/1Hl2MX4aVVKztw9nXPQudEcqzI7up46MrE1wujp8zqTI/edit#gid=999123567" target="_blank">流れ</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right toggle-class="b-nav-item-text-icon">
                <template v-slot:button-content>
                    <small>設定</small>
                    <br>
                    <font-awesome-icon icon="cogs" class="fa-fw" />
                </template>
                <template v-if="auth_level === '300'">
                    <b-dropdown-item to="/settings/app">システム設定</b-dropdown-item>
                </template>
                <template v-if="auth_level >= '200'">
                    <b-dropdown-item to="/settings/users">ユーザー</b-dropdown-item>
                </template>

                <b-dropdown-item to="/settings/shippings/addresses">住所</b-dropdown-item>
                <b-dropdown-item to="/settings/shippings/items">内容物</b-dropdown-item>
                <b-dropdown-item to="/settings/shippings/hscodes">HSコード/原産国</b-dropdown-item>
                <b-dropdown-item to="/settings/shippings/boxes">梱包</b-dropdown-item>
                <b-dropdown-item to="/settings/listings/html">商品説明HTML</b-dropdown-item>
                <template v-if="auth_level === '300'">
                </template>
<!--
                <b-dropdown-item to="/settings/shippings/boxes">梱包</b-dropdown-item>
                <b-dropdown-item to="/settings/shippings/to">受取人</b-dropdown-item>
                <b-dropdown-item to="/settings/shippings/item">申告商品</b-dropdown-item>
                <b-dropdown-item to="/settings/shippings/box">梱包</b-dropdown-item>
-->
            </b-nav-item-dropdown>
            <b-nav-item to="/me" link-classes="b-nav-item-text-icon">
                <small>My</small>
                <br>
                <font-awesome-icon icon="user" class="fa-fw" />
            </b-nav-item>
        </b-navbar-nav>
    </b-navbar>
</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
            'env',
            'auth_level',
            'auth_name',
            'auth_functions',
        ])
    },
    methods: {
        logout () {
            this.$store.dispatch('auth/logout')
        },
        login () {
            this.$store.dispatch('auth/login')
        },
    },
}
</script>
